// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__1ANSJ","section-1":"About_section-1__Z-6z6","content":"About_content__pLDsf","section-2":"About_section-2__9oNvI"};